import { useContext } from 'react';
import { PublicCompanyContext } from '../contexts/PublicCompanyProvider';

export const usePublicCompany = () => useContext(PublicCompanyContext);
